export function removeCarriageReturn(str: string): string {
  return str.replace(/[\r]/g, '');
}
